import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import History from './History';

import { AppState } from '../../../../store';
import { getItemById as getItem } from '../../../../store/prescription/actions';

import HistoryInterface from '../../../../interfaces/history';
import PrescriptionInterface from '../../../../interfaces/prescription';

import { fetch } from '../../../../services/history';

interface StateProps {
  prescription: PrescriptionInterface;
  mustUpdateHistory: boolean;
}

interface DispatchProps {
  getItemById: Function;
}

type Props = StateProps & DispatchProps;

const HistoryContainer: React.FC<Props> = ({ getItemById, mustUpdateHistory, prescription }: Props) => {
  const [items, setItems] = useState<Array<HistoryInterface>>([]);
  const [loading, isLoading] = useState<boolean>(true);
  const [error, hasError] = useState<boolean>(false);

  useEffect(() => {
    if (!mustUpdateHistory) {
      return;
    }

    isLoading(true);
    hasError(false);
    setItems([]);

    fetch(prescription.token).then(
      (i: HistoryInterface[]) => {
        isLoading(false);
        hasError(false);
        setItems(i);
      },
      () => {
        isLoading(false);
        hasError(true);
      },
    );
  }, [mustUpdateHistory, prescription.token]);

  return <History items={items} error={error} loading={loading} getItemById={getItemById} />;
};

const mapStateToProps = ({ prescription }: AppState): StateProps => ({
  prescription: prescription.prescription,
  mustUpdateHistory: prescription.mustUpdateHistory,
});

const mapDispatchToProps = {
  fetch,
  getItemById: getItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryContainer);
